import { createSlice } from '@reduxjs/toolkit'

const editorSlice = createSlice({
  name: 'editor',
  initialState: {
    currentContentHtml: '',
    currentSelection: {
      index: 0,
      length: 0,
    }
  },
  reducers: {
    setCurrentContentHtml(state, { payload }) {
      state.currentContentHtml = payload;
    },
    setCurrentSelection(state, { payload }) {
      state.currentSelection.index = payload.index;
      state.currentSelection.length = payload.length;
    },
  }
});

export const { setCurrentContentHtml } = editorSlice.actions;
export const editorReducer = editorSlice.reducer;

export default editorSlice;